module.exports = "<h1 matDialogTitle>{{confirmTitle}}</h1>\n<div mat-dialog-content>{{confirmMessage}}</div>\n<div mat-dialog-actions class=\"pt-24\">\n    <button mat-raised-button class=\"mat-accent mr-16\" (click)=\"dialogRef.close(true)\">{{okTBtn}}</button>\n    <button mat-button (click)=\"dialogRef.close(false)\">{{cancelBtn}}</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/@fuse/components/confirm-dialog/confirm-dialog.component.html
// module id = ./src/@fuse/components/confirm-dialog/confirm-dialog.component.html
// module chunks = main